import { Button, Input } from "antd";
import styled from "styled-components";
import { media } from "@/theme/breakpoints";

export const MainContainer = styled.div`
  border-left: 1px solid #dfe3e8;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
  box-sizing: border-box;

  ${media.downTablet`
    border-left: none;
  `}
`;

export const InnerContainer = styled.div`
  padding-left: 60px;

  ${media.downTablet`
    padding-left: 0;
    padding-top: 8px;
  `}
`;

export const MainHeading = styled.h3`
  margin: 0px;
  color: #000;
  text-align: left;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  text-transform: capitalize;
  margin-bottom: 25px;

  ${media.downMobile`
    font-size: 20px;
    margin-bottom: 16px;
  `}
`;

export const StyledTitle = styled.h4`
  margin: 0px;
  color: #585858;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  line-height: 80px;

  ${media.downTablet`
    line-height: 1.4;
    text-align: left;
    padding: 0;
  `}
`;

export const StyledRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  border-top: 1px solid #dfe3e8;
  border-bottom: 1px solid #dfe3e8;
  align-items: center;
  gap: 12px;

  ${media.downTablet`
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    padding: 16px;
    margin-bottom: 12px;
    border: 1px solid #e8ecf0;
    border-radius: 10px;
    background: #fafbfc;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

    ${StyledTitle}:first-child {
      font-size: 13px;
      font-weight: 500;
      color: #6b7280;
      text-transform: uppercase;
      letter-spacing: 0.03em;
    }

    ${StyledTitle}:nth-child(2) {
      font-size: 17px;
      font-weight: 500;
      color: #111;
      text-transform: none;
      letter-spacing: normal;
    }
  `}
`;

export const StyledPhoneRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 12px;

  ${media.downTablet`
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    padding: 16px;
    border: 1px solid #e8ecf0;
    border-radius: 10px;
    background: #fafbfc;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

    ${StyledTitle}:first-child {
      font-size: 13px;
      font-weight: 500;
      color: #6b7280;
      text-transform: uppercase;
      letter-spacing: 0.03em;
    }

    ${StyledTitle}:nth-child(2) {
      font-size: 17px;
      font-weight: 500;
      color: #111;
      text-transform: none;
      letter-spacing: normal;
    }
  `}
`;

export const StyledButton = styled.a`
  color: #ed6928;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  text-transform: capitalize;
  line-height: 80px;
  cursor: pointer;

  ${media.downTablet`
    line-height: 1.4;
    align-self: flex-start;
    min-height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    border: 1px solid #ed6928;
    border-radius: 8px;
    background: #fff;
  `}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const StyledButtonSpacer = styled(StyledButton)`
  visibility: hidden;
  pointer-events: none;
  user-select: none;

  ${media.downTablet`
    display: none;
  `}
`;

export const StyledInput = styled(Input)`
  width: 30%;
  line-height: 30px;
  margin-left: 15%;

  ${media.downTablet`
    width: 100%;
    margin-left: 0;
    min-height: 44px;
    font-size: 16px;
  `}
`;

export const StyledImageUploadWrapper = styled.div`
  margin-top: 20px;
`;

export const StyledInnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
  border: 1px solid #dfe3e8;
  background: #fff;
  padding: 30px;
  gap: 16px;

  ${media.downMobile`
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
  `}
`;

export const StyledSubHeading = styled.h5`
  margin: 0px;
  color: #585858;
  text-align: left;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  text-transform: capitalize;
`;

export const StyledSubHeading2 = styled.h6`
  margin: 0px;
  color: #ed6928;
  text-align: left;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  text-transform: capitalize;
`;

export const StyledUploadButton = styled(Button)`
  height: 50px;
  padding: 0px 25px;
  border-radius: 4px;
  text-align: center;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  background-color: #ed6928;
  color: #fff;

  ${media.downMobile`
    width: 100%;
    height: 44px;
    font-size: 16px;
  `}
`;
